import { render, staticRenderFns } from "./ModalPrescricao.vue?vue&type=template&id=17e34646&"
import script from "./ModalPrescricao.vue?vue&type=script&lang=js&"
export * from "./ModalPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports